import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function ModCard({ mod }) {
  const navigate = useNavigate();
  const { addToCart, isInCart } = useCart();

  const formatPrice = (cents) => {
    return `$${(cents / 100).toFixed(2)}`;
  };

  const handleAddToCart = (e) => {
    e.preventDefault();
    addToCart(mod);
  };

  const handleBuyNow = (e) => {
    e.preventDefault();
    navigate(`/mod/${mod.id}`);
  };

  // Check if this is a subscription product
  const isSubscription = mod.isSubscription || mod.subscription || false;

  // Color scheme based on payment type
  const accentColor = isSubscription ? 'blue-400' : 'green-500';
  const accentColorRgb = isSubscription ? '0,243,255' : '34,197,94';
  const accentColorHex = isSubscription ? '#00f3ff' : '#00ff41';

  return (
    <Link
      to={`/mod/${mod.id}`}
      className="group holo-card bg-[#0a110e]"
      style={{
        clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)'
      }}
    >
      <div className="relative aspect-square overflow-hidden bg-black">
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110 grayscale group-hover:grayscale-0"
          style={{ backgroundImage: `url(${mod.image})` }}
        />
        <div className="absolute top-0 right-0 p-2 flex flex-col gap-2 items-end">
          <span className={`bg-${accentColor} text-black text-xs font-bold px-2 py-1 uppercase tracking-wider`}>
            {mod.category}
          </span>
          {isSubscription && (
            <span className="bg-blue-400 text-black text-[10px] font-bold px-2 py-1 uppercase tracking-wider">
              Subscription
            </span>
          )}
          {!isSubscription && (
            <span className="bg-green-500 text-black text-[10px] font-bold px-2 py-1 uppercase tracking-wider">
              One-Time
            </span>
          )}
        </div>
      </div>

      <div className="p-6 border-t border-white/10">
        <div className="flex justify-between items-start mb-2">
          <h4 className={`text-xl font-bold text-white group-hover:text-${accentColor} transition-colors`} style={{fontFamily: 'Space Grotesk, sans-serif'}}>
            {mod.name}
          </h4>
          <div className="flex flex-col items-end">
            <span className={`text-${accentColor} font-mono font-bold`}>{formatPrice(mod.price)}</span>
            {isSubscription && (
              <span className="text-[10px] text-gray-500 font-mono">/month</span>
            )}
          </div>
        </div>

        <p className="text-gray-500 text-xs font-mono mb-2 border-l-2 border-white/10 pl-2">
          &gt; By {mod.author}<br/>
          &gt; {mod.rating} ★ ({mod.reviews} reviews)
        </p>

        <div className="mb-4 flex gap-2 flex-wrap">
          {mod.tags.slice(0, 2).map((tag, index) => (
            <span
              key={index}
              className="text-[10px] text-gray-500 font-mono uppercase"
            >
              #{tag}
            </span>
          ))}
        </div>

        <div className="flex gap-2">
          <button
            onClick={handleAddToCart}
            disabled={isInCart(mod.id)}
            className={`flex-1 py-3 border font-mono uppercase text-xs font-bold flex items-center justify-center gap-2 transition-all ${
              isInCart(mod.id)
                ? isSubscription
                  ? 'border-blue-400/50 text-blue-400 bg-blue-400/10 cursor-not-allowed'
                  : 'border-green-500/50 text-green-500 bg-green-500/10 cursor-not-allowed'
                : isSubscription
                  ? 'border-white/20 text-white hover:bg-white/10 hover:border-blue-400/50'
                  : 'border-white/20 text-white hover:bg-white/10 hover:border-green-500/50'
            }`}
          >
            <span className="material-symbols-outlined text-sm">
              {isInCart(mod.id) ? 'check_circle' : 'add_shopping_cart'}
            </span>
            {isInCart(mod.id) ? 'In Cart' : 'Add'}
          </button>
          <button
            onClick={handleBuyNow}
            className={`flex-1 py-3 text-black font-mono uppercase text-xs font-bold flex items-center justify-center gap-2 transition-all ${
              isSubscription
                ? 'bg-blue-400 hover:bg-white shadow-[0_0_10px_rgba(0,243,255,0.2)] hover:shadow-[0_0_20px_#00f3ff]'
                : 'bg-green-500 hover:bg-white shadow-[0_0_10px_rgba(34,197,94,0.2)] hover:shadow-[0_0_20px_#00ff41]'
            }`}
          >
            <span className="material-symbols-outlined text-sm">shopping_cart_checkout</span>
            {isSubscription ? 'Subscribe' : 'Buy Now'}
          </button>
        </div>
      </div>
    </Link>
  );
}

export default ModCard;
